import React, { useContext } from "react";
import styled from "@emotion/styled";

import NewsContext from "./NewsContext";

// style rules
import { Sizes, Colors } from "../../styles";
import NewsCard from "./NewsCard";
import NoResults from "../NoResults";
import Pagination from "../pagination/Pagination";
import Loading from "../Loading";

const NewsGrid = () => {
	const {
		data: { newsItems, totalPages, currentPageNumber, isLoading },
		actions: {
			handleButtonPageSelect,
			handleDecrementPage,
			handleIncrementPage,
		},
	} = useContext(NewsContext);

	const renderNewsCard = () => {
		if (isLoading) {
			return <Loading />;
		}
		if (newsItems.length === 0) {
			return <NoResults text={"No articles found"} color={Colors.base.black} />;
		}
		return (
			<Grid>
				{newsItems.map((item) => {
					return <NewsCard key={item.slug} newsItem={item} />;
				})}
			</Grid>
		);
	};

	return (
		<Container aria-label="American rivers news section">
			{renderNewsCard()}
			{totalPages && totalPages.length > 0 && (
				<Pagination
					handleDecrementPage={handleDecrementPage}
					handleIncrementPage={handleIncrementPage}
					totalPages={totalPages}
					handleButtonPageSelect={handleButtonPageSelect}
					currentPageNumber={currentPageNumber}
				/>
			)}
		</Container>
	);
};

export default NewsGrid;

const Container = styled.div`
	padding: 5.4rem 0 8rem 0;
`;

const Grid = styled.ul`
	display: ${(props) => (props.isEmpty ? "block" : "grid")};
	grid-template-columns: 1fr;
	gap: 2.5rem;
	margin: 0;
	padding: 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));
	}
`;
